import type { FC, ReactNode } from 'react'
import type { ConsortiumSlug } from '@/types'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import { buttonClassName } from '@/components/generals/button'
import { SectionHeading } from '@/components/landing/section-heading'
import { ConsortiumCard } from '@/components/landing/consortium-card'
import { consortiumCategories } from '@/constants/consorcios'

interface OtherCategoriesSectionProps {
    current: ConsortiumSlug
}

export const OtherCategoriesSection: FC<OtherCategoriesSectionProps> = ({ current }): ReactNode => {
    const others = consortiumCategories.filter(category => category.slug !== current)

    return (
        <section aria-labelledby='outros-consorcios-titulo' className='py-24 sm:py-28'>
            <div className='mx-auto max-w-7xl px-5 sm:px-8'>
                <div className='flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between'>
                    <SectionHeading
                        id='outros-consorcios-titulo'
                        eyebrow='Outros planos'
                        title='Conheça os outros consórcios'
                    />

                    <Link href='/#simulador' className={buttonClassName({ variant: 'outline', className: 'self-start lg:self-auto' })}>
                        Comparar no simulador
                        <ArrowRight aria-hidden='true' className='size-4' />
                    </Link>
                </div>

                <ul className='mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4'>
                    {others.map(category => (
                        <li key={category.slug}>
                            <ConsortiumCard category={category} />
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}
